var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Chip, darken, lighten } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Text from "../Text";
import { COLORS } from "../../../constants";
var Tag = function (_a) {
    var _b = _a.fontCategory /* Text category */, fontCategory = _b === void 0 ? "primary" : _b /* Text category */, bgcolor = _a.bgcolor, label = _a.label, _c = _a.deleteIcon, deleteIcon = _c === void 0 ? _jsx(CloseIcon, {}) : _c, sx = _a.sx, rest = __rest(_a, ["fontCategory", "bgcolor", "label", "deleteIcon", "sx"]);
    var svgColor = fontCategory === "primary"
        ? COLORS.P_MED_EMPHASIS
        : fontCategory === "onsurface"
            ? COLORS.S_HIGH_EMPHASIS
            : COLORS.ERROR_DARK;
    var svgHover = fontCategory === "primary" ? COLORS.P_HIGH_EMPHASIS : COLORS.LIGHT_GREY;
    var styles = useMemo(function () {
        return (__assign({ py: 0.5, px: 2, bgcolor: bgcolor, height: "auto", borderRadius: 1, "&.MuiChip-clickableColorDefault": {
                "&:hover": {
                    bgcolor: fontCategory === "primary"
                        ? darken(bgcolor, 0.1)
                        : lighten(bgcolor, 0.2),
                },
            }, ".MuiChip-label": {
                padding: 0,
                display: "block",
            }, ".MuiChip-icon": {
                p: 0,
                m: 0,
                mr: 2,
                width: 12,
                height: 12,
                color: svgColor,
            }, ".MuiChip-deleteIcon": {
                p: 0,
                m: 0,
                ml: 2,
                width: 12,
                height: 12,
                color: svgColor,
                "&:hover": {
                    color: svgHover,
                },
            } }, sx));
    }, [fontCategory, bgcolor]);
    return (_jsx(Chip, __assign({ sx: styles, deleteIcon: deleteIcon, label: _jsx(Text, __assign({ variant: "body3", category: fontCategory }, { children: label })) }, rest)));
};
export default Tag;
